import { Socket } from 'phoenix';
import { Auth } from 'aws-amplify';
import { getApiHost, getAppSecure, logoutWithRedirectBack } from '~/common/utils';

class WebSocket {
  constructor(props) {
    this.version = '0.0.1';
    this.channel = props.channel;
  }

  static url() {
    return getAppSecure('websocket') + getApiHost() + '/socket';
  }

  static async token() {
    return await Auth.currentSession()
      .then(res => res.idToken.jwtToken)
      .catch((err) => {
        if (err.code === "NotAuthorizedException") {
          // If refresh token, or current session is expired,
          // Logout and redirect users.
          logoutWithRedirectBack()
        }
      });
  }

  connect = async () => {
    return WebSocket.token()
      .then(token => {
        const params = { token };
        this.socket = new Socket(WebSocket.url(), { params });
        return this.socket.connect();
      })
      .then(() => {
        console.log('SOCKET CONNECTED \n');
      });
  };

  getChannel() {
    const channel = this.socket.channel(this.channel);

    channel
      .join()
      .receive('ok', resp => console.log('CHANNEL JOINED:', channel.topic, '\n'))
      .receive('error', err => {
        console.log('CHANNEL ERROR:', channel.topic, '\n', err);
        throw new Error(err);
      });

    return channel;
  }
}

export default WebSocket;



// WEBPACK FOOTER //
// ./src/common/websocket.js